/**
 * Return
 * @param {*} signal
 */
export function signalMultiplicityPattern(signal) {
    let js = signal.js;
    let pattern = '';
    if (js && js.length > 0) {
        for (let coupling of js) {
            pattern += coupling.multiplicity;
        }
    }
    else if (signal.delta) {
        pattern = '';
    }
    else {
        pattern = 'm';
    }
    return pattern;
}
//# sourceMappingURL=signalMultiplicityPattern.js.map